import { StatusQuestionConfig, StatusResponseState } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { Text } from 'react-native-paper';
import { RoutineQuestionMessage, RoutineQuestionMessageProps } from '../types';

export const StatusQuestionMessage: RoutineQuestionMessage<
  StatusQuestionConfig,
  StatusResponseState
> = (
  props: RoutineQuestionMessageProps<StatusQuestionConfig, StatusResponseState>
) => {
  const { response } = props;
  const { t } = useTranslation();

  const routineOpenEndedResponseText = response?.openEndedResponse
    ? `${t('routines.status.admin.openEndedResponse')}: ${
        response.openEndedResponse
      }`
    : '';
  const routineText = `Status: ${response?.status ?? '-'}
${routineOpenEndedResponseText}`;

  return <Text style={props.textStyle}>{routineText}</Text>;
};
